exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "/*\nWebsite to find color names corresponding to hash code\nhttp://chir.ag/projects/name-that-color/\nhttp://www.color-hex.com/color/da70d6\n */\nul {\n  margin: 0;\n  padding: 0;\n  list-style-type: none; }\n", "", {"version":3,"sources":["/./components/AppContainer/AppContainer.scss"],"names":[],"mappings":"AAAA;;;;GAIG;AACH;EACE,UAAU;EACV,WAAW;EACX,sBAAsB,EAAE","file":"AppContainer.scss","sourcesContent":["/*\nWebsite to find color names corresponding to hash code\nhttp://chir.ag/projects/name-that-color/\nhttp://www.color-hex.com/color/da70d6\n */\nul {\n  margin: 0;\n  padding: 0;\n  list-style-type: none; }\n"],"sourceRoot":"webpack://"}]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader?{"sourceMap":true,"modules":true,"localIdentName":"[name]_[local]_[hash:base64:3]","minimize":false}!../~/postcss-loader?pack=sass!../~/sass-loader!./components/AppContainer/AppContainer.scss
// module id = 43
// module chunks = 0